/** Sent by the IoT portal iframe after an IoT system was created or edited successfully (IBM-1064). */
export const IOT_SYSTEM_SAVED = 'IOT_SYSTEM_SAVED';

/**
 * Reads an `IOT_SYSTEM_SAVED` postMessage payload (`{ type, systemId }`).
 * Returns null for any other message; the id is normalized to a string.
 */
export const parseIotSystemSavedMessage = (data: unknown): { systemId: string } | null => {
    if (!data || typeof data !== 'object') return null;
    const { type, systemId } = data as { type?: unknown; systemId?: unknown };
    if (type !== IOT_SYSTEM_SAVED) return null;
    if (typeof systemId === 'number' && Number.isFinite(systemId)) return { systemId: String(systemId) };
    if (typeof systemId === 'string' && systemId.trim()) return { systemId: systemId.trim() };
    return null;
};
